import React, { useState } from 'react';
import { UserIcon, LockIcon, EyeIcon, EyeOffIcon, CoffeeIcon } from 'lucide-react';
import Button from '../ui/Button';
interface BaristaLoginProps {
  onLogin: () => void;
}
const BaristaLogin: React.FC<BaristaLoginProps> = ({
  onLogin
}) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!username || !password) {
      setError('Please enter both username and password');
      return;
    }
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      // For demo purposes, accept any login
      setIsLoading(false);
      onLogin();
    }, 1500);
  };
  return <div className="h-full bg-[#1A237E] flex flex-col items-center justify-center p-6" data-id="element-723">
      <div className="w-full max-w-xs" data-id="element-724">
        <div className="flex flex-col items-center mb-10" data-id="element-725">
          <div className="w-20 h-20 rounded-full bg-[#00E4BB]/20 flex items-center justify-center mb-4" data-id="element-726">
            <CoffeeIcon className="w-10 h-10 text-[#00E4BB]" data-id="element-727" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2 font-gt-ultra" data-id="element-728">
            Barista Admin
          </h1>
          <p className="text-[#00E4BB] text-center" data-id="element-729">
            Location management dashboard
          </p>
        </div>
        {error && <div className="bg-red-500/20 border border-red-500/30 text-red-200 px-4 py-3 rounded-lg mb-6" data-id="element-730">
            {error}
          </div>}
        <form onSubmit={handleLogin} className="space-y-6" data-id="element-731">
          <div data-id="element-732">
            <label className="block text-[#00E4BB] mb-2 text-sm" data-id="element-733">
              Username
            </label>
            <div className="relative" data-id="element-734">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-735">
                <UserIcon className="h-5 w-5 text-[#00E4BB]" data-id="element-736" />
              </div>
              <input type="text" value={username} onChange={e => setUsername(e.target.value)} className="w-full bg-[#1A237E]/60 border border-[#00E4BB]/30 rounded-lg pl-10 pr-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-[#00E4BB]" placeholder="Enter username" data-id="element-737" />
            </div>
          </div>
          <div data-id="element-738">
            <label className="block text-[#00E4BB] mb-2 text-sm" data-id="element-739">
              Password
            </label>
            <div className="relative" data-id="element-740">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-741">
                <LockIcon className="h-5 w-5 text-[#00E4BB]" data-id="element-742" />
              </div>
              <input type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} className="w-full bg-[#1A237E]/60 border border-[#00E4BB]/30 rounded-lg pl-10 pr-12 py-3 text-white focus:outline-none focus:ring-2 focus:ring-[#00E4BB]" placeholder="Enter password" data-id="element-743" />
              <button type="button" className="absolute inset-y-0 right-0 pr-3 flex items-center" onClick={() => setShowPassword(!showPassword)} data-id="element-744">
                {showPassword ? <EyeOffIcon className="h-5 w-5 text-[#00E4BB]" data-id="element-745" /> : <EyeIcon className="h-5 w-5 text-[#00E4BB]" data-id="element-746" />}
              </button>
            </div>
          </div>
          <div data-id="element-747">
            <Button type="submit" fullWidth className="bg-[#00E4BB] text-[#1A237E] border-none py-3" disabled={isLoading} data-id="element-748">
              {isLoading ? 'Logging in...' : 'Login to Dashboard'}
            </Button>
          </div>
        </form>
        <div className="mt-8 text-center" data-id="element-749">
          <a href="#" className="text-[#00E4BB] text-sm hover:underline" data-id="element-750">
            Forgot password?
          </a>
        </div>
        <div className="mt-12 text-center" data-id="element-751">
          <p className="text-xs text-gray-400" data-id="element-752">
            Smart Soda Hydrate+ Admin v1.0
          </p>
        </div>
      </div>
    </div>;
};
export default BaristaLogin;